export default "__VITE_ASSET__Cxws7hZr__"